const API_BASE = (process.env.VUE_APP_API_BASE || 'http://localhost:8082').replace(/\/$/, '');

export function apiUrl(path) {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE}${normalized}`;
}

export { API_BASE };
